"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LangUtils_1 = require("./LangUtils");
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
    }
    EventEmitter.prototype._getTypeListeners = function (type) {
        if (!this._listeners) {
            this._listeners = {};
        }
        var tl = this._listeners[type];
        if (!tl) {
            tl = [];
            this._listeners[type] = tl;
        }
        return tl;
    };
    EventEmitter.prototype._hasTypeListener = function (type) {
        return this._listeners && this._listeners[type] ? true : false;
    };
    EventEmitter.prototype.hasListenerOfType = function (type) {
        return this._hasTypeListener(type);
    };
    EventEmitter.prototype.containsListener = function (type, listener) {
        if (this._hasTypeListener(type)) {
            var tl = this._listeners[type];
            return tl.some(function (reg) {
                return reg.o === listener;
            });
        }
        return false;
    };
    EventEmitter.prototype.addEventListener = function (type, listener) {
        if (type && listener && !this.containsListener(type, listener)) {
            var tl = this._getTypeListeners(type);
            if (LangUtils_1.isFunction(listener)) {
                tl.push({ o: listener, f: listener });
            }
            else {
                tl.push({
                    o: listener,
                    f: function (event) {
                        listener.handleEvent(event);
                    }
                });
            }
        }
    };
    EventEmitter.prototype.on = function (type, listener) {
        this.addEventListener(type, listener);
    };
    EventEmitter.prototype.removeEventListener = function (type, listener) {
        if (this._hasTypeListener(type)) {
            var tl = this._listeners[type];
            var idx = tl.findIndex(function (reg) {
                return reg.o === listener;
            });
            if (idx >= 0) {
                tl.splice(idx, 1);
                if (tl.length === 0) {
                    delete this._listeners[type];
                }
            }
        }
    };
    EventEmitter.prototype.off = function (type, listener) {
        this.removeEventListener(type, listener);
    };
    EventEmitter.prototype.emit = function (event) {
        if (event && event.type && this._hasTypeListener(event.type)) {
            var tl = this._listeners[event.type];
            tl.forEach(function (reg) {
                reg.f(event);
            });
        }
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
